import { render, staticRenderFns } from "./AppTopBar.vue?vue&type=template&id=540b50b4&scoped=true&"
import script from "./AppTopBar.vue?vue&type=script&lang=js&"
export * from "./AppTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b50b4",
  null
  
)

export default component.exports